import React, { useEffect, useState } from "react";
import "./FullScreenAnimation.css"; // Add styles for the animation
import useAuth from "../../hooks/useAuth";

const FullScreenAnimation = ({ onAnimationEnd }) => {
  const { authenticated } = useAuth();
  useEffect(() => {
    // Function to create the divs
    const createDivs = () => {
      const scene = document.querySelector(".scene");
      for (let i = 0; i < 210; i++) {
        const star = document.createElement("div");
        // Randomized styles for the stars
        const x = `${Math.random() * 200}vmax`;
        const y = `${Math.random() * 100}vh`;
        const z = `${Math.random() * 200 - 100}vmin`;
        const rx = `${Math.random() * 360}deg`;
        star.style.setProperty("--x", x);
        star.style.setProperty("--y", y);
        star.style.setProperty("--z", z);
        star.style.setProperty("--rx", rx);

        const delay = `${Math.random() * 0.5}s`;
        star.style.animationDelay = delay;
        scene.appendChild(star);
      }
    };

    createDivs(); // Run on mount
  }, []);
  useEffect(() => {
    // Set a timer for the animation duration
    const timer = setTimeout(() => {
      onAnimationEnd(); // Callback to end the animation
    }, 6000); // Duration in milliseconds (3 seconds)

    return () => clearTimeout(timer); // Clean up the timer
  }, [onAnimationEnd]);

  return (
    // <div className="full-screen-animation">
    //   <div className="animation-content">
    //     <h1>Welcome to Cyfonii!</h1>
    //     <div className="logo-animation"></div>
    //   </div>
    // </div>
    <div className="MainBodyAnimation">
      <div className="scene">
        <section
          style={{
            position: "absolute",
            top: "50%",

            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          className=""
        >
          <span className="md:flex  ">
            <small className="text-xl font-bold ">Hello, </small>
            <small className="text-xl font-bold text-yellow-300  ">
              {" "}
              {authenticated?.user?.name},
            </small>
            <small className="text-xl font-bold">
              You are now entering the portal.
            </small>
          </span>
        </section>
      </div>
    </div>
  );
};

export default FullScreenAnimation;
